import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/data/dataActions";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import { BiLinkExternal } from "react-icons/bi";


function NFTGallery(props) {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [NFTS, setNFTS] = useState([]);
  const [claimingRewards, setClaimingRewards] = useState(false);
  const [feedback, setFeedback] = useState("I hope today is your lucky day.");
  const ipfsBaseUrl = "";
  var nfturi = "";

  // fetch(ipfsBaseUrl + (nft.uri).substring(7))
  const fetchMetatDataForNFTS = () => {
    setNFTS([]);
    const galTokens = [...data.rpTokens, ...data.shTokens, ...data.csTokens, ...data.jbTokens, ...data.mbTokens];
    if(galTokens.length == 0){
      setFeedback("NFTs will display here if they are not staking");
    }else{
      setFeedback("Loading your NFT's" );
      setNFTS([]);
      galTokens.forEach((nft) => {
        if(nft.id != 0){
          nfturi = nft.uri
          nfturi = nfturi.replace('ipfs.infura.io', 'racex.mypinata.cloud')
          nfturi = nfturi.replace('gateway.pinata.cloud', 'racex.mypinata.cloud')
          fetch(nfturi)
          .then((response) => response.json())
          .then((metaData) => {
            setNFTS((initialState) => [
              ...initialState,
              { id: nft.id, metaData: metaData },
            ]);
          })
        }
          // .catch((err) => {
          //   console.log(err);
          // });
      });
      if(galTokens.length > 0){
        setFeedback("You have NFT's available for staking" );
      }else{
        setFeedback("NFTs will display here if they are not staking");
      }
    }
    // alert("No of NFTs = " + galTokens.length + " Tokens " + galTokens[0].id + " --- "  + galTokens[1].id + " --- "  + galTokens[2].id + " --- ");
  };


  useEffect(() => {
    fetchMetatDataForNFTS();
  }, [data.allTokens]);

  return (
    <section>
    <Container >
      <Particle />
      <Row style={{ justifyContent: "center", paddingTop: "40px" }}>
      </Row> 
      <Container className="nftmint-section" id="Minter">
        <h1 className="nftgallery-heading">
          <strong className="purple">My NFT's </strong>
        </h1><br/>
        <strong className="gold">{feedback}</strong>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {data.loading ? (
            <>
              <br/>
              <br/>
              <h5  className="gold" style={{ textAlign: "center" }}>
                loading...
              </h5>
            </>
          ) : (
          NFTS.map((nft, index) => {
            return(
              <Col md={4} className="nft-card">
                <Card className="nft-card-view" key={nft.id+nft.metaData.name}>
                  <Card.Text>&nbsp;&nbsp;&nbsp;Name :{nft.metaData.name} #{nft.id}</Card.Text>
                  <Card.Text>&nbsp;&nbsp;&nbsp;Description :{nft.metaData.description}</Card.Text>
                  <Card.Img variant="top" src={nft.metaData.image.replace('ipfs.infura.io', 'racex.mypinata.cloud')} alt="card-img" />
                  <Card.Body>
                    <Card.Text style={{ textAlign: "justify" }}>
                      {nft.metaData.description}
                    </Card.Text>
                    <Button variant="primary" href={nft.metaData.image.replace('ipfs.infura.io', 'racex.mypinata.cloud')} target="_blank">
                      <BiLinkExternal /> &nbsp;
                      {"View NFT"}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })
          )}
        </Row>

        <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
      </Container>
    </Container>
    </section>
  );
}

export default NFTGallery;
